import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Logo.module.css';
import logoImg from './img/logo.png';

const Logo: React.FC = () => {
  return (
      <Link to="/" aria-label="TourByTrain — Home">
          <img src={logoImg} alt="TourByTrain" className={styles.logoImg} />
      </Link>
  );
};

export default Logo;
